import React from "react";
import { useHistory } from "react-router-dom";
import TableChartIcon from "@mui/icons-material/TableChart";
import PlantillaScreen from "../helpers/PlantillaScreen";

export const MenuList = ({ titulo, cards }) => {
    const history = useHistory();

    const ArrowIcon = () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
    );

    const ICONS = [
        // clipboard-list
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
            <rect x="9" y="3" width="6" height="4" rx="1" />
            <path d="M9 12h6M9 16h4" />
        </svg>,
        // bar-chart
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 20V10M12 20V4M6 20v-6" />
        </svg>,
        // check-circle
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>,
        // search
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
        </svg>,
        // file-text
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
        </svg>,
        // activity
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>,
    ];


    const onPush = (ruta) => {
        // console.log(ruta)
        if (ruta === "/Credito/CarteraClientes") {
            history.push(ruta, {
                permisos: [
                    { idsucursal: 1 },
                    { idsucursal: 2 },
                    { idsucursal: 11 },
                    { idsucursal: 12 },
                    { idsucursal: 21 },
                    { idsucursal: 22 },
                    { idsucursal: 31 },
                    { idsucursal: 32 },
                    { idsucursal: 41 },
                    { idsucursal: 42 },
                    { idsucursal: 51 },
                    { idsucursal: 52 },
                    { idsucursal: 61 },
                ],
                filtro: "C",
                ruta: 'C'
            });
            return;
        }
        if (ruta === "/Postventa/Dashboard") {
            history.push(ruta, {
                sucursales: "",
                adr: "",
                ejercicio: new Date().getFullYear(),
                periodo_inicio: new Date().getMonth() + 1,
                periodo_fin: new Date().getMonth() + 1,
                regresar: false
            });
            return;
        }
        if (ruta === "/Ventas/Cotizaciones") {
            localStorage.removeItem("filtrosCotizaciones");
            // return;
        }
        history.push(ruta);
    };

    const isEmpty = !cards || cards.length === 0;

    return (
        <PlantillaScreen
            titulo={"LISTADO AUDITORIA"}
            className={"holacxc"}
        >
            {/* <!-- MAIN CONTENT --> */}
            <main className="content scroll">


                {/* ✅ .card-grid VA FUERA del .map() */}
                {isEmpty ? (
                    <div className="empty-state">Sin módulos disponibles</div>
                ) : (
                    <div className="card-grid">
                        {cards.map((card, index) => (
                            <div
                                key={card.ruta || index}
                                className="module-card"
                                style={{ animationDelay: `${index * 55}ms` }}
                                onClick={() => onPush(card.ruta)}
                            >
                                {/* Número en marca de agua */}
                                <span className="card-watermark" aria-hidden="true">
                                    {String(index + 1).padStart(2, "0")}
                                </span>

                                {/* Ícono */}
                                <div className="card-icon">
                                    {ICONS[index % ICONS.length]}
                                </div>

                                {/* Título */}
                                <div className="card-body">
                                    <h3 className="card-title">{card.titulo}</h3>
                                </div>

                                {/* Footer */}
                                <div className="card-footer">
                                    <span className="card-action">
                                        Ver detalle
                                        <ArrowIcon />
                                    </span>
                                    <span className="card-tag">#{String(index + 1).padStart(2, "0")}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

            </main>
        </PlantillaScreen>
    );
    return (
        <div className="container-boxes-list">
            <div className="container-boxes-list-titulo">
                <div className="container-boxes-list-titulo-text">{titulo}</div>
                <div className="container-boxes-list-titulo-efecto">
                    <div className="container-boxes-list-titulo-efecto-bl"></div>
                    <div className="container-boxes-list-titulo-efecto-circle"></div>
                    <div className="container-boxes-list-titulo-efecto-br"></div>
                </div>
            </div>
            <div className="container-boxes-list-container">
                {cards === undefined || cards === null || cards.lenght === 0 ? (
                    <div></div>
                ) : (
                    cards.map((card) => (
                        <div
                            className="container-boxes-list-container-card"
                            onClick={() => onPush(card.ruta)}
                        >
                            <TableChartIcon /> {card.titulo}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};
